import {
  useSaveHirerTeamMemberJobAccessAndNotify,
  type SaveJobAccessAndNotifyTrackingData,
  type StepActionResult,
} from '@seek/hirer-team-member-job-access';

import getTrackingAdapter from 'src/app/dataAnalytics';
import {
  NOTIFICATIONS_TEAM_EMAIL_CONFIRM_BTN_PRESSED,
  NOTIFICATION_TEAM_SELECT_CONFIRM_BTN_PRESSED,
} from 'src/app/dataAnalytics/schema/constants';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import type { Tealium } from 'src/types/appState';

import { sendSaveTeamMemberAccessNotifyEvent } from '../../utils/sendNotificationsSettingEvents';

const getEventName = (notificationTeamAddCount?: number) =>
  notificationTeamAddCount && notificationTeamAddCount > 0
    ? NOTIFICATIONS_TEAM_EMAIL_CONFIRM_BTN_PRESSED
    : NOTIFICATION_TEAM_SELECT_CONFIRM_BTN_PRESSED;

export const useHandleSaveJobAccessAndNotify = (tealium: Tealium) => {
  const saveTeamMemberJobAccessAndNotify =
    useSaveHirerTeamMemberJobAccessAndNotify();

  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const sendTeamMemberAccessNotifyEvent = (
    data: SaveJobAccessAndNotifyTrackingData,
  ) => {
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: getEventName(data.notificationTeamAddCount),
        ...data,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendSaveTeamMemberAccessNotifyEvent(tealium, data);
    }
  };

  const handleSaveJobAccessAndNotify = async (): Promise<StepActionResult> => {
    const { success, error } = await saveTeamMemberJobAccessAndNotify(
      sendTeamMemberAccessNotifyEvent,
    );
    return { success, error };
  };

  return handleSaveJobAccessAndNotify;
};
